/**
 * Add here all non Angular init for the app
 */
(function(document, jQuery) {'use strict';
	jQuery(document).ready(function($) {
		// i18n for month Calender
		$.MonthPicker.i18n = {
			year: 'Année',
			prevYear: 'Précédente',
			nextYear: 'Suivante',
			next12Years: 'Avancer de 12 ans',
			prev12Years: 'Reculer de 12 ans',
			nextLabel: 'Suiv.',
			prevLabel: 'Préc.',
			buttonText: 'Ouvrir le Calendrier',
			jumpYears: 'Sauter des années',
			backTo: 'Retour à',
			months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
		};

		// Force datepicker to display full month name
		$.datepicker._defaults.monthNamesShort = $.datepicker._defaults.monthNames;
		$.datepicker._defaults.dayNamesMin = $.datepicker._defaults.dayNamesShort;

		Highcharts.setOptions({
			chart: {
				style: {
					fontFamily: 'Roboto',
					fontWeight: 300,
				}
			}
		});

		/*$.fn.peity.defaults.pie = {
		  fill: ["#0A75E2", "#CEE7FF"],
		};*/
	});

})(document, jQuery);
